import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PageTitleStrategy extends TitleStrategy {
  private _title = inject(Title);
  private _transloco = inject(TranslocoService);

  constructor() {
    super();
  }

  updateTitle(routerState: RouterStateSnapshot) {
    const title = this.buildTitle(routerState);
    if (title !== undefined) {
      this._transloco
        .selectTranslate(title)
        .pipe(take(1))
        .subscribe((loadedTitle) => {
          if (loadedTitle || title) {
            this._title.setTitle(`Vinajet | ${loadedTitle ?? title}`);
          } else {
            this._title.setTitle('Vinajet');
          }
        });
    }
  }
}
